(function () {
  const SELECTOR = '.cs-announcement-timer';
  const INIT_ATTR = 'data-timer-initialized';

  const pad = (n) => (n < 10 ? '0' + n : '' + n);

  const decompose = (ms) => {
    if (ms <= 0) return null;
    const total = Math.floor(ms / 1000);
    const d = Math.floor(total / 86400);
    const h = Math.floor((total % 86400) / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;
    return { d, h, m, s };
  };

  function initOne(el) {
    if (el.getAttribute(INIT_ATTR) === '1') return;

    const endStr   = el.getAttribute('data-timer-end');
    const startStr = el.getAttribute('data-timer-start');
    const cont     = String(el.getAttribute('data-timer-continue')) === 'true';
    const valueEl  = el.querySelector('.cs-announcement-timer__value');

    if (!endStr || !valueEl) return;

    const rawD = el.getAttribute('data-label-d') || '';
    const rawH = el.getAttribute('data-label-h') || '';
    const rawM = el.getAttribute('data-label-m') || '';
    const rawS = el.getAttribute('data-label-s') || '';
    const L = {
      d: typeof rawD === 'string' ? rawD.trim() : '',
      h: typeof rawH === 'string' ? rawH.trim() : '',
      m: typeof rawM === 'string' ? rawM.trim() : '',
      s: typeof rawS === 'string' ? rawS.trim() : '',
    };

    const end = new Date(endStr).getTime();

    if (startStr && !cont) {
      const start = new Date(startStr).getTime();
      if (Date.now() < start) {
        el.style.display = 'none';
        return;
      }
    }

    const formatLabeled = (ms) => {
      const p = decompose(ms);
      if (!p) return null;
      const parts = [];
      if (p.d > 0) parts.push(p.d + L.d);
      parts.push(pad(p.h) + L.h);
      parts.push(pad(p.m) + L.m);
      parts.push(pad(p.s) + L.s);
      return parts.join(' ');
    };

    const tick = () => {
      const left = end - Date.now();
      const out = formatLabeled(left);
      if (!out) {
        el.style.display = 'none';
        return;
      }
      valueEl.textContent = out;
    };

    tick();
    const id = setInterval(() => {
      if (!document.body.contains(el)) return clearInterval(id);
      tick();
    }, 1000);

    el.setAttribute(INIT_ATTR, '1');
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  window.addEventListener('load', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', initAll);
  setTimeout(initAll, 0);
  setTimeout(initAll, 500);
  setTimeout(initAll, 1500);
})();
